import { unauthenticatedPagePromo } from '@gonfalon/dogfood-flags/dogfood-flags';

export enum UnauthenticatedPageThemes {
  default = 'off',
  dark = 'dark-theme',
}

export enum UnauthenticatedPagePromos {
  disabled = 'off',
  galaxy2025 = 'galaxy-2025',
  reinvent2025 = 'reinvent-2025',
  agentControlLaunch2026 = 'agent-control-launch-2026',
  handsOnWithAgentControl = 'hands-on-with-agentcontrol',
  controlPanel2026 = 'control-panel-2026',
  runtimeLabBanner = 'runtime-lab-banner',
}

export const shouldShowUnauthenticatedPagePromo = () =>
  unauthenticatedPagePromo() !== UnauthenticatedPagePromos.disabled;
